import { Component, OnInit, OnDestroy, Directive, Input, HostListener, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MatSnackBar, MatPaginator, MatTableDataSource } from '@angular/material';
import {Sort} from '@angular/material';

import { EguardConfigService } from '../../../../core/services/config.service';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { EguardValidationService } from '../../../../core/components/validation/validation.service';
import { CaseService } from '../../../shared/services/case.service';
import { UserService } from '../../../shared/services/user.service';
import { OrganizationServices } from '../../../shared/services/organization.services';
import { Case } from '../../../shared/models/case';
import { EguardConfirmatialogComponent } from '../../../../core/components/confirm-dialog/confirm-dialog.component';
import { EguardCustomLoaderService } from '../../../../core/components/custom-loader/custom-loader.service';
import { StatusService } from '../../../shared/services/status.service';
import { LocalUserService } from '../../../shared/services/localUser';
import { environment } from '../../../../../environments/environment';
import { HeaderTitleService } from 'app/services/header-title.service';

@Component({
  selector: 'eguard-clerk-cases-component',
  templateUrl: './clerk-cases.component.html',
  styleUrls: ['./clerk-cases.component.scss'],
  providers: [
    StatusService,
    LocalUserService
  ]
})
export class EguardClerkCasesComponent implements OnInit, OnDestroy {

  cases = new MatTableDataSource<any>();
  org: any;
  reorderable = true;
  organizationId: string;
  private sub: any;
  dialogRef: any;
  users: any;
  token: string;

  userNames: any = [];

  error: string;

  casesForReview: any[];
  openCases: any[];
  caseAllData: any;
  openCasesLoading = true;
  casesForReviewLoading = true;
  loadingIndicator = true;
  displayedColumns: string[] = ['caseNo', 'status', 'creationDate', 'modifiedDate', 'createdBy', 'modifyBy']
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private eguardConfig: EguardConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private caseService: CaseService,
    public dialog: MatDialog,
    private cognito: CognitoUtil,
    private userService: UserService,
    private organizationServices: OrganizationServices,
    private localUser: LocalUserService,
    private eguardCustomLoaderService: EguardCustomLoaderService,

    public snackBar: MatSnackBar,
    public statusService: StatusService,
    private headerService: HeaderTitleService
  ) {

  }

  ngOnInit() {
    this.org = this.localUser.getOrganizationId();
    this.getAllCases(this.org);
    setTimeout(() => { this.sendHeaders(); });
  }
  sendHeaders(): void {
    this.headerService.sendHeader('assignment', `Cases`)
  }
  ngOnDestroy() {

  }

  ngAfterViewInit() {
    this.cases.paginator = this.paginator;
  }

  onDetailToggle(event) {
  }


  toggleExpandRow(row) {

  }

  getAllCases(orgID: string) {
    this.caseService.getAllCases(orgID)
      .subscribe(
        data => {
          this.cases.data = data;
          this.caseAllData = data;
          this.openCasesLoading = false;
          this.getUserNames();
        },
        Error => {
          this.error = Error;
        }
      );
  }

  getUserNames() {
    this.userNames = [];

    let usersUnique = [];

    for (let i = 0; i < this.cases.data.length; i++) {

      let modifyBy = this.cases.data[i].summary.modified_by;
      let createdBy = this.cases.data[i].summary.created_by;

      if (usersUnique.indexOf(modifyBy) === -1) {
        usersUnique.push(modifyBy);
        this.getUserName(modifyBy);
      }

      if (usersUnique.indexOf(createdBy) === -1) {
        usersUnique.push(createdBy);
        this.getUserName(createdBy);
      }

    }
  }

  getCasesByStatus(orgId: string) {

    let listOfStatus = this.statusService.listOfStatus;
    let openCaseStatuses = this.statusService.openCaseStatuses;

    this.casesForReview = [];
    this.casesForReviewLoading = true;
    this.openCases = [];

    this.caseService.getCasesByStatus(orgId, listOfStatus.join(','))
      .subscribe(data => {

        for (let i = 0; i < listOfStatus.length; i++) {
          this.casesForReview = this.casesForReview.concat(data[listOfStatus[i]]);
        }

        this.casesForReviewLoading = false;

      }, error => {

        this.error = 'This page had an error please refresh if this continues contact support';
        this.snackBar.open(this.error, '', {
          duration: environment.snackBarErrorLength,
        });

      });

    this.caseService.getCasesByStatus(orgId, openCaseStatuses.join(','))
      .subscribe(data => {

        for (let i = 0; i < openCaseStatuses.length; i++) {
          this.openCases = this.openCases.concat(data[openCaseStatuses[i]]);
        }



      }, error => {

        this.error = 'This page had an error please refresh if this continues contact support';
        this.snackBar.open(this.error, '', {
          duration: environment.snackBarErrorLength,
        });
        this.openCasesLoading = false;
      });

  }

  getUserName(id) {
    this.userService.getUser(id)
      .subscribe(result => {

        let userName = '';

        if (result.first_name !== null && result.first_name !== undefined) {
          userName = result.first_name;
        }

        if (result.last_name !== null && result.last_name !== undefined) {
          userName += userName == '' ? result.last_name : ' ' + result.last_name;
        }

        if (userName === '') {
          userName = 'No Name';
        }

        this.userNames[id] = userName;

      });
  }

  // this will give you the status of a case EX: FILED_FOR_CLERK
  // give caseId
  getStatus(id) {
    for (let i = 0; i < this.cases.data.length; i++) {
      if (this.cases.data[i].id === id) {
        return this.cases.data[i].summary.status;
      }
    }
  }

  // this returns the current form EX: TWOTHREE
  // give caseID
  getCurrentForm(id) {
    for (let i = 0; i < this.cases.data.length; i++) {
      if (this.cases.data[i].id === id) {
        return this.cases.data[i].summary.current_form;
      }
    }
  }

  getStatusText(caseId) {

    let status = this.getStatus(caseId);
    let currentForm = this.getCurrentForm(caseId);

    return this.statusService.getStatusText('CLERK', status, currentForm);
  }

  viewFiles(row: any) {
    this.router.navigate(['/cases/openCases/documents/' + this.org + '/' + row.id]);
  }
  openCase(id) {
    this.router.navigate(['case', this.org, id]);
  }

  sortData(sort: Sort) {
    const data = this.caseAllData.slice();
    if (!sort.active || sort.direction == '') {
      this.cases.data = data;
      return;
    }

    this.cases.data  = data.sort((a, b) => {
      let isAsc = sort.direction == 'asc';
      switch (sort.active) {
        case 'CaseNumber': return compare(a.summary.case_number, b.summary.case_number, isAsc);
        case 'creationDate' : return compare(a.summary.created_date, b.summary.created_date, isAsc);     
        case 'modifiedDate' : return compare(a.summary.modified_date, b.summary.modified_date, isAsc); 
        default: return 0;
      }
    });
    function compare(a, b, isAsc) {
      return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
    
  }
  

}




// WEBPACK FOOTER //
// ./src/app/main/content/common/cases/clerk-cases.component.ts